import isString from 'lodash/isString';
import time from 'yoda-core-components/lib/moment/Time';
import { buildReturnStatus } from 'yoda-account-components/lib/common/orderDetailsFetchUtil';
import orderBy from 'lodash/orderBy';
import forEach from 'lodash/forEach';
import { map, toUpper } from 'lodash';
import moment from 'moment';

/**
 * Return filters with previous two years along with config filters
 * @param noOfPreviousYears
 * @param NewOrdersFilterOptions
 * @return Array of Object
 */
export const getFilterDropdown = (noOfPreviousYears, NewOrdersFilterOptions) => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const ordersFilter = [...NewOrdersFilterOptions];
    const prevYears = [];
    const isObject = NewOrdersFilterOptions.some((value) => {
        return typeof value === 'object';
    });
    for (let i = 0; i <= noOfPreviousYears; i += 1) {
        const year = currentYear - i;
        if (isObject) {
            prevYears.push({ key: year, value: year });
        } else {
            prevYears.push(year.toString());
        }
    }
    ordersFilter.splice(2, 0, ...prevYears);
    return [...ordersFilter];
};

export const getFilterQuery = (fetchLastSupportedYears, filter) => {
    const date = new Date();
    const currentYear = date.getFullYear().toString();
    let dateFrom = '';
    let dateTo = time();
    if (filter === 'all') {
        dateFrom = time(`${currentYear - fetchLastSupportedYears}-01-01`);
    } else if (filter === currentYear) {
        dateFrom = time(`${filter}-01-01`);
    } else if (isString(filter) && filter.indexOf('20') > -1) {
        dateFrom = time(`${filter}-01-01`);
        dateTo = time(`${filter}-12-31`);
    } else {
        dateFrom = time().subtract(filter, 'months');
    }
    return [dateFrom, dateTo];
};

export const sortReturnLists = (returnLists, isRefundSummary) => {
    if (isRefundSummary) {
        const sortedList = orderBy(returnLists, ['returnCompletedDate'], ['desc']);
        return [...sortedList];
    }
    const InprogressItems = [];
    const otherStatusItems = [];
    forEach(returnLists, (list) => {
        list.returnStatus === 'InProgress'
            ? InprogressItems.push(list)
            : otherStatusItems.push(list);
    });
    const sortedList = orderBy(otherStatusItems, ['returnCompletedDate'], ['desc']);
    return [...InprogressItems, ...sortedList];
};

export const formatReturnsLineItem = (appsPassedLineItem, returns = []) => {
    return appsPassedLineItem.map((item) => {
        if (item.product && !item.product.pdpLink) {
            item.product.pdpLink = item.product.imageURL;
        }
        if (item.product && !item.product.sku) {
            item.product.sku = {
                id: item.product.id,
                modelNumber: item.product.modelNumber || '',
                quantity: item.product.quantity,
                attributes: item.product.attributes || [],
            };
        }
        if (item.fulfillmentType) {
            item.fulfillmentOption = {
                fullFillmentType: item.fulfillmentType,
            };
        }
        if (item.totals) {
            map(item.totals, (total) => {
                if (total.name) {
                    if (toUpper(total.name) === 'ITEM AMOUNT') {
                        total.name = 'Total Price';
                        total.amount = total.amount ? total.amount : 0;
                    }
                }
            });
        }
        if (item.returnTracking && item.returnTracking.length > 0) {
            const { returnTracking } = item;
            const returnTrackingInfo = buildReturnStatus(returnTracking, returns);
            item.returnTracking = returnTrackingInfo;
        }
        return item;
    });
};

export const quantityOptions = (item) => {
    const quantities =
        item.maxAllowedAdjustments?.map(({ quantity }) => ({
            key: quantity,
            value: quantity,
        })) || [];
    quantities.unshift({ key: 'select', value: 'Select quantity ...' });
    return quantities;
};

export const formatDate = (date, dateFormat, ignoreZone = false) => {
    const formattedDate = !ignoreZone
        ? moment(date).parseZone(date).format(dateFormat)
        : moment(date).local().format(dateFormat);
    return formattedDate !== 'Invalid date' ? formattedDate : date;
};
